<template>
  <div>
    <list
      ref="refHierarchicalLevelList"
      sort-by="NivelJerarquicoId"
      :refetch-records="fetchHierarchicalLevels"
      refetch-records-name="nivelesJerarquicos"
      :actions="actions"
      key-field="nivelJerarquicoId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteHierarchicalLevel"
      :filters.sync="filters"
    />
  </div>
</template>
<script>

import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import organizationChart from '@/services/organizationchart.service'

export default {
  components: {
    List,
  },
  setup() {
    /* Refs */
    const refHierarchicalLevelList = ref(null)
    /* Services */
    const {
      fetchHierarchicalLevels,
      deleteHierarchicalLevel,
    } = organizationChart()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('organizationChart.hierarchicalLevel.columns.name'),
        key: 'nombre',
      },
      {
        label: i18n.t('organizationChart.hierarchicalLevel.columns.order'),
        key: 'orden',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'NivelJerarquico',
        routeName: 'apps-organization-chart-hierarchical-level-edit',
        params: ['nivelJerarquicoId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'NivelJerarquico',
        params: ['nivelJerarquicoId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        routeName: 'apps-organization-chart-hierarchical-level-add',
        label: i18n.t('Routes.HierarchicalLevelAdd'),
        aclAction: 'create',
        aclResource: 'NivelJerarquico',
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      refHierarchicalLevelList,
      tableColumns,
      tableActions,
      actions,
      filters,
      fetchHierarchicalLevels,
      deleteHierarchicalLevel,
    }
  },
}
</script>
